import {Routes} from '@angular/router';
import {RequestPasswordResetComponent} from './request-password-reset/request-password-reset.component';
import {PasswordResetComponent} from './password-reset.component';

export const routes: Routes = [
    {
        path: 'auth/request-password-reset',
        component: RequestPasswordResetComponent
    }, {
        path: 'auth/password-reset',
        component: PasswordResetComponent
    }
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/password-reset/password-reset.routing.ts